

import Vue from 'vue'
import Component from "vue-class-component";
import {namespace} from "vuex-class";
import {IOnOffHandlers} from "bonomo/dist";
import {Prop, VModel} from "vue-property-decorator";
import {IAuthUserData} from "@/store/modules/authModule";
import {IErrors} from "@/model/IErrors";

const webhookModule = namespace("webhookModule");
const authModule = namespace("authModule");

enum allowedWebhookActions {
  orders = 'orders/webhook',
  users = 'users/webhook'
}
@Component({})
export default class WebhookCreationDialog extends Vue {
  @VModel()
  private show!: boolean;

  @Prop()
  private userId!: number;

  @authModule.Getter('userData')
  private user!: IAuthUserData;

  @webhookModule.Action('createWebhook')
  private createWebhook!: (myObj: any) => void;

  @webhookModule.Action('resetErrors')
  private resetErrors!: () => void;

  @webhookModule.Getter('errors')
  private errors!: IErrors;

  private url: string|null = null;
  private action: string|null = allowedWebhookActions.orders;
  private secret: string|null = null;

  private subscribes: IOnOffHandlers = {};

  private actionList: string[] = [
    allowedWebhookActions.orders,
    allowedWebhookActions.users
  ]
  private loading: boolean = false;

  created() {
    this.subscribes = this.$ons({
      'login.OK': this.onClose,
      'backend.call.OK.webhookCreated': this.onBackendOk,
      'backend.call.KO.webhookCreated': this.onBackendKO,
    });
  }

  beforeDestroy() {
    this.$offs(this.subscribes);
  }

  private onBackendOk() {
    this.onClose();
    this.loading = false;
  }

  private onBackendKO() {
    this.loading = false;
  }

  private onClose() {
    this.url = null;
    this.resetErrors();
    this.show = false;
  }

  private onCreate() {
    this.loading = true;
    this.createWebhook({
      user_id: this.userId,
      action: this.action,
      url: this.url,
      secret: this.secret
    });

  }

}
